<template>
    <div class="popup-container" v-on:click.self="closePopup">
        <div class="popup">
            <button class="popup__close" v-on:click="closePopup">Close</button>
            <div class="right-content">
                <img src="assets/images/popup_bg.png" alt="Popup Background" />
            </div>
            <div class="left-content">
                <img src="assets/images/logo_colored.svg" alt="PlanIt Logo" />

                <p>Sign up to keep track of your trips</p>

                <div class="facebook-continue">
                    <!-- For Visual Purposes only, should be replaced with proper facebook plugin during production: https://developers.facebook.com/docs/facebook-login/web/login-button/ -->
                    <button class="temp-facebook-btn">
                        <i class="facebook-icon"></i>Continue with Facebook
                    </button>
                </div>

                <div class="or-border">or</div>

                <form>
                    <input type="email" placeholder="Email Address" />
                    <input type="text" placeholder="User Name" />
                    <input type="password" placeholder="Password" />

                    <div class="field-row">
                        <input type="text" placeholder="First Name" />
                        <input type="text" placeholder="Last Name" />
                    </div>

                    <button type="submit" class="main-btn" v-on:click="loginUser">Sign Up</button>

                    <p>Have an account? <a href="">Log In</a></p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'SignUpPopup',
        methods: {
            closePopup: function() {
                Eventbus.$emit('closeSignUpPopup')
            },
            loginUser: function() {
                Eventbus.$emit('loginUser')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/accountPopup";
</style>
